// Auto-generated by scripts/split_ui.js from data/health.js — do not edit.
export const HEALTH_UI = {
  "pageTitle": {
    "id": "Sehat di Tanah Suci",
    "en": "Healthy in the Holy Land",
    "ar": "صحتك في الأراضي المقدسة",
    "fr": "En bonne santé en Terre Sainte",
    "de": "Gesund im Heiligen Land",
    "es": "Saludable en la Tierra Santa",
    "ru": "Здоровье на Святой Земле",
    "zh": "在圣地保持健康",
    "ja": "聖地での健康管理",
    "ko": "성지에서의 건강",
    "hi": "पवित्र भूमि में स्वस्थ रहें"
  },
  "pageSub": {
    "id": "Menu seimbang, program latihan, dan rutinitas harian agar tetap prima selama Umrah & Haji",
    "en": "Balanced menu, exercise program, and daily routines to stay at your best during Umrah & Hajj",
    "ar": "قائمة طعام متوازنة وبرنامج تمارين وروتين يومي للحفاظ على لياقتك خلال العمرة والحج",
    "fr": "Menu équilibré, programme d'exercices et routines quotidiennes pour rester en pleine forme pendant la Umrah et le Hajj",
    "de": "Ausgewogener Ernährungsplan, Trainingsprogramm und tägliche Routinen, um während Umrah & Hajj fit zu bleiben",
    "es": "Menú equilibrado, programa de ejercicios y rutinas diarias para mantenerte en óptimas condiciones durante la Umrah y el Hajj",
    "ru": "Сбалансированное питание, программа упражнений и ежедневный распорядок для поддержания отличного самочувствия во время Умры и Хаджа",
    "zh": "均衡饮食、锻炼计划和日常作息，助您在乌姆拉与朝觐期间保持最佳状态",
    "ja": "ウムラとハッジの間、最高の体調を維持するためのバランスの取れた食事、運動プログラム、および日課",
    "ko": "우므라 & 하지 기간 동안 최상의 컨디션을 유지하기 위한 균형 잡힌 식단, 운동 프로그램 및 일상 루틴",
    "hi": "उमरा और हज के दौरान बेहतरीन स्वास्थ्य बनाए रखने के लिए संतुलित आहार, व्यायाम कार्यक्रम और दैनिक दिनचर्या"
  },
  "tabMenu": {
    "id": "Menu 7 Hari",
    "en": "7-Day Menu",
    "ar": "قائمة الطعام لـ 7 أيام",
    "fr": "Menu de 7 jours",
    "de": "7-Tage-Menü",
    "es": "Menú de 7 días",
    "ru": "Меню на 7 дней",
    "zh": "7天饮食计划",
    "ja": "7日間の食事メニュー",
    "ko": "7일 식단",
    "hi": "7 दिन का मेनू"
  },
  "tabPhases": {
    "id": "Menu per Fase",
    "en": "Menu by Phase",
    "ar": "القائمة حسب المرحلة",
    "fr": "Menu par phase",
    "de": "Menü nach Phase",
    "es": "Menú por fase",
    "ru": "Меню по этапам",
    "zh": "按阶段的饮食计划",
    "ja": "フェーズ別メニュー",
    "ko": "단계별 식단",
    "hi": "चरण के अनुसार मेनू"
  },
  "tabProgram": {
    "id": "Program 8 Minggu",
    "en": "8-Week Program",
    "ar": "برنامج 8 أسابيع",
    "fr": "Programme de 8 semaines",
    "de": "8-Wochen-Programm",
    "es": "Programa de 8 semanas",
    "ru": "Программа на 8 недель",
    "zh": "8周训练计划",
    "ja": "8週間プログラム",
    "ko": "8주 프로그램",
    "hi": "8 सप्ताह का कार्यक्रम"
  },
  "tabRoutines": {
    "id": "Rutinitas Harian",
    "en": "Daily Routines",
    "ar": "الروتين اليومي",
    "fr": "Routines quotidiennes",
    "de": "Tägliche Routinen",
    "es": "Rutinas diarias",
    "ru": "Ежедневные процедуры",
    "zh": "每日作息",
    "ja": "日課",
    "ko": "일일 루틴",
    "hi": "दैनिक दिनचर्या"
  },
  "tabRefs": {
    "id": "Rujukan Pakar",
    "en": "Expert References",
    "ar": "المراجع المتخصصة",
    "fr": "Références d'experts",
    "de": "Expertenreferenzen",
    "es": "Referencias de expertos",
    "ru": "Экспертные источники",
    "zh": "专家参考资料",
    "ja": "専門家の参考文献",
    "ko": "전문가 참고자료",
    "hi": "विशेषज्ञ संदर्भ"
  },
  "dayTotal": {
    "id": "Total ±{n} kkal",
    "en": "Total ±{n} kcal",
    "ar": "الإجمالي ±{n} سعرة حرارية",
    "fr": "Total ±{n} kcal",
    "de": "Gesamt ±{n} kcal",
    "es": "Total ±{n} kcal",
    "ru": "Итого ±{n} ккал",
    "zh": "总计 ±{n} 千卡",
    "ja": "合計 ±{n} kcal",
    "ko": "총 ±{n} kcal",
    "hi": "कुल ±{n} किलोकैलोरी"
  },
  "dailyTarget": {
    "id": "Target harian 1.800–2.200 kkal · air 2–4 L sesuai cuaca",
    "en": "Daily target 1,800–2,200 kcal · water 2–4 L according to weather",
    "ar": "الهدف اليومي 1800–2200 سعرة حرارية · الماء 2–4 لتر حسب الطقس",
    "fr": "Objectif quotidien 1 800–2 200 kcal · eau 2–4 L selon la météo",
    "de": "Tagesziel 1.800–2.200 kcal · Wasser 2–4 L je nach Wetter",
    "es": "Objetivo diario 1.800–2.200 kcal · agua 2–4 L según el clima",
    "ru": "Суточная норма 1800–2200 ккал · вода 2–4 л в зависимости от погоды",
    "zh": "每日目标 1,800–2,200 千卡 · 饮水 2–4 升（视天气而定）",
    "ja": "1日の目標 1,800〜2,200 kcal · 水分 天候に応じて2〜4 L",
    "ko": "일일 목표 1,800–2,200 kcal · 수분 날씨에 따라 2–4 L",
    "hi": "दैनिक लक्ष्य 1,800–2,200 किलोकैलोरी · पानी मौसम के अनुसार 2–4 लीटर"
  },
  "mealSarapan": {
    "id": "Sarapan",
    "en": "Breakfast",
    "ar": "الإفطار",
    "fr": "Petit-déjeuner",
    "de": "Frühstück",
    "es": "Desayuno",
    "ru": "Завтрак",
    "zh": "早餐",
    "ja": "朝食",
    "ko": "아침 식사",
    "hi": "नाश्ता"
  },
  "mealCamilanPagi": {
    "id": "Camilan pagi",
    "en": "Morning snack",
    "ar": "وجبة خفيفة صباحية",
    "fr": "Collation du matin",
    "de": "Morgensnack",
    "es": "Merienda de la mañana",
    "ru": "Утренний перекус",
    "zh": "上午点心",
    "ja": "午前のおやつ",
    "ko": "오전 간식",
    "hi": "सुबह का नाश्ता (हल्का)"
  },
  "mealSiang": {
    "id": "Makan siang",
    "en": "Lunch",
    "ar": "الغداء",
    "fr": "Déjeuner",
    "de": "Mittagessen",
    "es": "Almuerzo",
    "ru": "Обед",
    "zh": "午餐",
    "ja": "昼食",
    "ko": "점심 식사",
    "hi": "दोपहर का भोजन"
  },
  "mealCamilanSore": {
    "id": "Camilan sore",
    "en": "Afternoon Snack",
    "ar": "وجبة خفيفة بعد الظهر",
    "fr": "Collation de l'après-midi",
    "de": "Nachmittagssnack",
    "es": "Merienda de la tarde",
    "ru": "Полдник",
    "zh": "下午点心",
    "ja": "午後のおやつ",
    "ko": "오후 간식",
    "hi": "दोपहर बाद का नाश्ता"
  },
  "mealMalam": {
    "id": "Makan malam",
    "en": "Dinner",
    "ar": "العشاء",
    "fr": "Dîner",
    "de": "Abendessen",
    "es": "Cena",
    "ru": "Ужин",
    "zh": "晚餐",
    "ja": "夕食",
    "ko": "저녁 식사",
    "hi": "रात का खाना"
  },
  "mealCamilan": {
    "id": "Camilan",
    "en": "Snack",
    "ar": "وجبة خفيفة",
    "fr": "Collation",
    "de": "Snack",
    "es": "Merienda",
    "ru": "Перекус",
    "zh": "点心",
    "ja": "おやつ",
    "ko": "간식",
    "hi": "नाश्ता"
  },
  "kcal": {
    "id": "±{n} kkal",
    "en": "±{n} kcal",
    "ar": "±{n} سعرة حرارية",
    "fr": "±{n} kcal",
    "de": "±{n} kcal",
    "es": "±{n} kcal",
    "ru": "±{n} ккал",
    "zh": "±{n} 千卡",
    "ja": "±{n} kcal",
    "ko": "±{n} kcal",
    "hi": "±{n} किलो कैलोरी"
  },
  "followedToday": {
    "id": "Saya mengikuti menu ini hari ini",
    "en": "I followed this menu today",
    "ar": "اتبعت هذه القائمة اليوم",
    "fr": "J'ai suivi ce menu aujourd'hui",
    "de": "Ich habe dieses Menü heute befolgt",
    "es": "Seguí este menú hoy",
    "ru": "Я следовал этому меню сегодня",
    "zh": "我今天遵循了这份菜单",
    "ja": "今日このメニューに従いました",
    "ko": "오늘 이 메뉴를 따랐습니다",
    "hi": "मैंने आज यह मेनू अपनाया"
  },
  "followedDone": {
    "id": "Menu seimbang tercatat untuk hari ini",
    "en": "Balanced menu recorded for today",
    "ar": "تم تسجيل القائمة المتوازنة لهذا اليوم",
    "fr": "Menu équilibré enregistré pour aujourd'hui",
    "de": "Ausgewogenes Menü für heute erfasst",
    "es": "Menú equilibrado registrado para hoy",
    "ru": "Сбалансированное меню записано на сегодня",
    "zh": "今日均衡饮食已记录",
    "ja": "今日のバランスメニューが記録されました",
    "ko": "오늘의 균형 잡힌 메뉴가 기록되었습니다",
    "hi": "आज के लिए संतुलित मेनू दर्ज किया गया"
  },
  "goalLabel": {
    "id": "Tujuan",
    "en": "Goal",
    "ar": "الهدف",
    "fr": "Objectif",
    "de": "Ziel",
    "es": "Objetivo",
    "ru": "Цель",
    "zh": "目标",
    "ja": "目標",
    "ko": "목표",
    "hi": "लक्ष्य"
  },
  "principlesLabel": {
    "id": "Prinsip utama",
    "en": "Main Principles",
    "ar": "المبادئ الأساسية",
    "fr": "Principes fondamentaux",
    "de": "Grundprinzipien",
    "es": "Principios fundamentales",
    "ru": "Основные принципы",
    "zh": "主要原则",
    "ja": "基本原則",
    "ko": "주요 원칙",
    "hi": "मुख्य सिद्धांत"
  },
  "sampleDay": {
    "id": "Contoh menu sehari",
    "en": "Sample daily menu",
    "ar": "نموذج قائمة طعام يومية",
    "fr": "Exemple de menu journalier",
    "de": "Beispiel-Tagesmenü",
    "es": "Ejemplo de menú diario",
    "ru": "Пример дневного меню",
    "zh": "每日菜单示例",
    "ja": "1日のサンプルメニュー",
    "ko": "하루 식단 예시",
    "hi": "दिन भर के भोजन का नमूना"
  },
  "energyLabel": {
    "id": "Energi",
    "en": "Energy",
    "ar": "الطاقة",
    "fr": "Énergie",
    "de": "Energie",
    "es": "Energía",
    "ru": "Энергия",
    "zh": "能量",
    "ja": "エネルギー",
    "ko": "에너지",
    "hi": "ऊर्जा"
  },
  "waterLabel": {
    "id": "Cairan",
    "en": "Fluids",
    "ar": "السوائل",
    "fr": "Liquides",
    "de": "Flüssigkeiten",
    "es": "Líquidos",
    "ru": "Жидкости",
    "zh": "液体摄入",
    "ja": "水分",
    "ko": "수분",
    "hi": "तरल पदार्थ"
  },
  "weekLabel": {
    "id": "Minggu {n}",
    "en": "Week {n}",
    "ar": "الأسبوع {n}",
    "fr": "Semaine {n}",
    "de": "Woche {n}",
    "es": "Semana {n}",
    "ru": "Неделя {n}",
    "zh": "第{n}周",
    "ja": "第{n}週",
    "ko": "{n}주차",
    "hi": "सप्ताह {n}"
  },
  "walkLabel": {
    "id": "Jalan kaki",
    "en": "Walking",
    "ar": "المشي",
    "fr": "Marche à pied",
    "de": "Gehen zu Fuß",
    "es": "Caminar",
    "ru": "Ходьба пешком",
    "zh": "步行",
    "ja": "徒歩",
    "ko": "도보",
    "hi": "पैदल चलना"
  },
  "strengthLabel": {
    "id": "Kekuatan & keseimbangan",
    "en": "Strength & Balance",
    "ar": "القوة والتوازن",
    "fr": "Force et équilibre",
    "de": "Kraft & Gleichgewicht",
    "es": "Fuerza y equilibrio",
    "ru": "Сила и равновесие",
    "zh": "力量与平衡",
    "ja": "筋力とバランス",
    "ko": "근력 및 균형",
    "hi": "शक्ति और संतुलन"
  },
  "flexLabel": {
    "id": "Kelenturan",
    "en": "Flexibility",
    "ar": "المرونة",
    "fr": "Souplesse",
    "de": "Beweglichkeit",
    "es": "Flexibilidad",
    "ru": "Гибкость",
    "zh": "柔韧性",
    "ja": "柔軟性",
    "ko": "유연성",
    "hi": "लचीलापन"
  },
  "seniorLabel": {
    "id": "Varian lansia / risiko tinggi",
    "en": "Elderly / High-Risk Variant",
    "ar": "نسخة كبار السن / المخاطر العالية",
    "fr": "Variante senior / à risque élevé",
    "de": "Senioren- / Hochrisiko-Variante",
    "es": "Variante para mayores / alto riesgo",
    "ru": "Вариант для пожилых / группы высокого риска",
    "zh": "老年人／高风险版本",
    "ja": "高齢者・高リスク向けバリアント",
    "ko": "노인 / 고위험군 변형",
    "hi": "वृद्ध / उच्च जोखिम संस्करण"
  },
  "noteLabel": {
    "id": "Catatan pelatih",
    "en": "Trainer's Note",
    "ar": "ملاحظة المدرب",
    "fr": "Note de l'entraîneur",
    "de": "Hinweis des Trainers",
    "es": "Nota del entrenador",
    "ru": "Заметка тренера",
    "zh": "教练备注",
    "ja": "トレーナーのメモ",
    "ko": "트레이너 메모",
    "hi": "प्रशिक्षक की टिप्पणी"
  },
  "walkSession": {
    "id": "Jalan {n}",
    "en": "Walk {n}",
    "ar": "جلسة المشي {n}",
    "fr": "Marche {n}",
    "de": "Spaziergang {n}",
    "es": "Caminata {n}",
    "ru": "Ходьба {n}",
    "zh": "步行 {n}",
    "ja": "ウォーク {n}",
    "ko": "걷기 {n}",
    "hi": "चलना {n}"
  },
  "strengthSession": {
    "id": "Kekuatan {n}",
    "en": "Strength {n}",
    "ar": "تمرين القوة {n}",
    "fr": "Force {n}",
    "de": "Kraft {n}",
    "es": "Fuerza {n}",
    "ru": "Сила {n}",
    "zh": "力量 {n}",
    "ja": "筋力トレーニング {n}",
    "ko": "근력 {n}",
    "hi": "शक्ति {n}"
  },
  "sessionsDone": {
    "id": "{done}/{total} sesi selesai",
    "en": "{done}/{total} sessions completed",
    "ar": "{done}/{total} جلسة مكتملة",
    "fr": "{done}/{total} séances terminées",
    "de": "{done}/{total} Sitzungen abgeschlossen",
    "es": "{done}/{total} sesiones completadas",
    "ru": "{done}/{total} сеансов завершено",
    "zh": "已完成 {done}/{total} 节课",
    "ja": "{done}/{total} セッション完了",
    "ko": "{done}/{total} 세션 완료",
    "hi": "{done}/{total} सत्र पूर्ण"
  },
  "programProgress": {
    "id": "Progres program: {done}/{total} sesi",
    "en": "Program progress: {done}/{total} sessions",
    "ar": "تقدم البرنامج: {done}/{total} جلسة",
    "fr": "Progression du programme : {done}/{total} séances",
    "de": "Programmfortschritt: {done}/{total} Sitzungen",
    "es": "Progreso del programa: {done}/{total} sesiones",
    "ru": "Прогресс программы: {done}/{total} сеансов",
    "zh": "计划进度：{done}/{total} 节课",
    "ja": "プログラムの進捗：{done}/{total} セッション",
    "ko": "프로그램 진행률: {done}/{total} 세션",
    "hi": "कार्यक्रम की प्रगति: {done}/{total} सत्र"
  },
  "libraryTitle": {
    "id": "Panduan gerakan",
    "en": "Movement guide",
    "ar": "دليل الحركات",
    "fr": "Guide des mouvements",
    "de": "Bewegungsanleitung",
    "es": "Guía de movimientos",
    "ru": "Руководство по движениям",
    "zh": "动作指南",
    "ja": "動作ガイド",
    "ko": "동작 가이드",
    "hi": "गतिविधि मार्गदर्शिका"
  },
  "howLabel": {
    "id": "Cara",
    "en": "How",
    "ar": "الطريقة",
    "fr": "Comment",
    "de": "Wie",
    "es": "Cómo",
    "ru": "Как",
    "zh": "方法",
    "ja": "方法",
    "ko": "방법",
    "hi": "तरीका"
  },
  "doseLabel": {
    "id": "Dosis",
    "en": "Dose",
    "ar": "الجرعة",
    "fr": "Dose",
    "de": "Dosis",
    "es": "Dosis",
    "ru": "Доза",
    "zh": "剂量",
    "ja": "用量",
    "ko": "복용량",
    "hi": "खुराक"
  },
  "routineDone": {
    "id": "Tandai rutinitas selesai hari ini",
    "en": "Mark routine as done for today",
    "ar": "ضع علامة على الروتين باعتباره مكتملاً اليوم",
    "fr": "Marquer la routine comme terminée aujourd'hui",
    "de": "Routine für heute als erledigt markieren",
    "es": "Marcar la rutina como completada hoy",
    "ru": "Отметить распорядок как выполненный на сегодня",
    "zh": "将今日常规标记为已完成",
    "ja": "本日のルーティンを完了済みにする",
    "ko": "오늘의 루틴을 완료로 표시",
    "hi": "आज की दिनचर्या को पूर्ण के रूप में चिह्नित करें"
  },
  "routineDoneToast": {
    "id": "Rutinitas tercatat sebagai olahraga hari ini",
    "en": "Routine recorded as today's exercise",
    "ar": "تم تسجيل الروتين كتمرين اليوم",
    "fr": "Routine enregistrée comme exercice du jour",
    "de": "Routine als heutiges Training aufgezeichnet",
    "es": "Rutina registrada como ejercicio de hoy",
    "ru": "Распорядок записан как сегодняшняя тренировка",
    "zh": "例程已记录为今日锻炼",
    "ja": "ルーティンが本日の運動として記録されました",
    "ko": "루틴이 오늘의 운동으로 기록되었습니다",
    "hi": "दिनचर्या आज के व्यायाम के रूप में दर्ज की गई"
  },
  "minutes": {
    "id": "{n} menit",
    "en": "{n} minutes",
    "ar": "{n} دقيقة",
    "fr": "{n} minutes",
    "de": "{n} Minuten",
    "es": "{n} minutos",
    "ru": "{n} минут",
    "zh": "{n} 分钟",
    "ja": "{n} 分",
    "ko": "{n} 분",
    "hi": "{n} मिनट"
  },
  "refsIntro": {
    "id": "Menu dan program di halaman ini merangkum pedoman yang dipublikasikan oleh lembaga gizi, kedokteran olahraga, dan fisioterapi berikut. Kami tidak mengutip pernyataan pribadi; angka yang dipakai berasal dari dokumen resmi.",
    "en": "The menus and programs on this page summarize guidelines published by the following nutrition, sports medicine, and physiotherapy institutions. We do not cite personal statements; the figures used are drawn from official documents.",
    "ar": "تلخّص القوائم والبرامج الواردة في هذه الصفحة الإرشادات الصادرة عن المؤسسات التالية المتخصصة في التغذية والطب الرياضي والعلاج الطبيعي. ولا نستشهد بتصريحات شخصية؛ إذ تُستقى الأرقام المستخدمة من الوثائق الرسمية.",
    "fr": "Les menus et programmes de cette page résument les recommandations publiées par les institutions suivantes spécialisées en nutrition, médecine du sport et physiothérapie. Nous ne citons pas de déclarations personnelles ; les chiffres utilisés proviennent de documents officiels.",
    "de": "Die Menüs und Programme auf dieser Seite fassen die Richtlinien der folgenden Einrichtungen für Ernährung, Sportmedizin und Physiotherapie zusammen. Wir zitieren keine persönlichen Aussagen; die verwendeten Zahlen stammen aus offiziellen Dokumenten.",
    "es": "Los menús y programas de esta página resumen las pautas publicadas por las siguientes instituciones de nutrición, medicina deportiva y fisioterapia. No citamos declaraciones personales; las cifras utilizadas provienen de documentos oficiales.",
    "ru": "Меню и программы на этой странице обобщают руководящие принципы, опубликованные следующими учреждениями в области питания, спортивной медицины и физиотерапии. Мы не приводим личные высказывания; используемые цифры взяты из официальных документов.",
    "zh": "本页的菜单和计划汇总了以下营养学、运动医学和物理治疗机构发布的指南。我们不引用个人声明；所用数据均来自官方文件。",
    "ja": "このページのメニューとプログラムは、以下の栄養学・スポーツ医学・理学療法機関が公表したガイドラインをまとめたものです。個人的な発言は引用しておらず、使用している数値はすべて公式文書に基づいています。",
    "ko": "이 페이지의 메뉴와 프로그램은 다음 영양학, 스포츠 의학 및 물리치료 기관이 발표한 지침을 요약한 것입니다. 개인적인 진술은 인용하지 않으며, 사용된 수치는 공식 문서에서 가져온 것입니다.",
    "hi": "इस पृष्ठ के मेनू और कार्यक्रम निम्नलिखित पोषण, खेल चिकित्सा और भौतिक चिकित्सा संस्थानों द्वारा प्रकाशित दिशानिर्देशों का सारांश प्रस्तुत करते हैं। हम व्यक्तिगत वक्तव्यों का हवाला नहीं देते; उपयोग किए गए आंकड़े आधिकारिक दस्तावेज़ों से लिए गए हैं।"
  },
  "disclaimer": {
    "id": "Informasi ini bersifat edukasi umum dan tidak menggantikan nasihat dokter, ahli gizi, atau fisioterapis Anda. Jamaah dengan penyakit jantung, diabetes, hipertensi, atau keterbatasan gerak wajib berkonsultasi sebelum memulai program.",
    "en": "This information is for general educational purposes and does not replace the advice of your doctor, nutritionist, or physiotherapist. Pilgrims with heart disease, diabetes, hypertension, or mobility limitations must consult a healthcare professional before starting any program.",
    "ar": "هذه المعلومات ذات طابع تعليمي عام ولا تُغني عن استشارة طبيبك أو أخصائي التغذية أو المعالج الطبيعي. يجب على الحجاج والمعتمرين المصابين بأمراض القلب أو السكري أو ارتفاع ضغط الدم أو محدودية الحركة استشارة مختص قبل البدء في أي برنامج.",
    "fr": "Ces informations sont à visée éducative générale et ne remplacent pas les conseils de votre médecin, nutritionniste ou physiothérapeute. Les pèlerins souffrant de maladies cardiaques, de diabète, d'hypertension ou de limitations de mobilité doivent consulter un professionnel de santé avant de commencer tout programme.",
    "de": "Diese Informationen dienen allgemeinen Bildungszwecken und ersetzen nicht den Rat Ihres Arztes, Ernährungsberaters oder Physiotherapeuten. Pilger mit Herzerkrankungen, Diabetes, Bluthochdruck oder Bewegungseinschränkungen müssen vor Beginn eines Programms einen Arzt konsultieren.",
    "es": "Esta información tiene fines educativos generales y no reemplaza el consejo de su médico, nutricionista o fisioterapeuta. Los peregrinos con enfermedades cardíacas, diabetes, hipertensión o limitaciones de movilidad deben consultar a un profesional de la salud antes de iniciar cualquier programa.",
    "ru": "Данная информация носит общеобразовательный характер и не заменяет рекомендации вашего врача, диетолога или физиотерапевта. Паломники с сердечными заболеваниями, диабетом, гипертонией или ограничениями подвижности обязаны проконсультироваться со специалистом перед началом любой программы.",
    "zh": "本信息仅供一般教育目的，不能替代医生、营养师或物理治疗师的建议。患有心脏病、糖尿病、高血压或行动不便的朝觉者在开始任何计划前必须咨询医疗专业人员。",
    "ja": "この情報は一般的な教育目的のものであり、医師・栄養士・理学療法士のアドバイスに代わるものではありません。心疾患、糖尿病、高血圧、または運動制限のある巡礼者は、プログラムを開始する前に必ず医療専門家に相談してください。",
    "ko": "이 정보는 일반 교육 목적으로 제공되며 의사, 영양사 또는 물리치료사의 조언을 대체하지 않습니다. 심장 질환, 당뇨병, 고혈압 또는 거동 제한이 있는 순례자는 프로그램을 시작하기 전에 반드시 의료 전문가와 상담해야 합니다.",
    "hi": "यह जानकारी सामान्य शैक्षिक उद्देश्यों के लिए है और आपके डॉक्टर, पोषण विशेषज्ञ या फिजियोथेरेपिस्ट की सलाह का विकल्प नहीं है। हृदय रोग, मधुमेह, उच्च रक्तचाप या गतिशीलता की सीमाओं वाले हाजियों को कोई भी कार्यक्रम शुरू करने से पहले किसी स्वास्थ्य विशेषज्ञ से परामर्श करना अनिवार्य है।"
  },
  "openFullMenu": {
    "id": "Lihat menu 7 hari & per fase",
    "en": "View 7-day & per-phase menu",
    "ar": "عرض القائمة لمدة 7 أيام وحسب كل مرحلة",
    "fr": "Voir le menu 7 jours & par phase",
    "de": "7-Tage- & Phasenmenü anzeigen",
    "es": "Ver menú de 7 días y por fase",
    "ru": "Просмотреть меню на 7 дней и по фазам",
    "zh": "查看7天及各阶段菜单",
    "ja": "7日間・フェーズ別メニューを見る",
    "ko": "7일 및 단계별 메뉴 보기",
    "hi": "7-दिवसीय और चरण-वार मेनू देखें"
  },
  "openFullProgram": {
    "id": "Lihat program 8 minggu & rutinitas",
    "en": "View 8-week program & routines",
    "ar": "عرض البرنامج لمدة 8 أسابيع والروتينات",
    "fr": "Voir le programme de 8 semaines & les routines",
    "de": "8-Wochen-Programm & Routinen anzeigen",
    "es": "Ver programa de 8 semanas y rutinas",
    "ru": "Просмотреть программу на 8 недель и распорядок",
    "zh": "查看8周计划及日常训练",
    "ja": "8週間プログラム＆ルーティンを見る",
    "ko": "8주 프로그램 및 루틴 보기",
    "hi": "8-सप्ताह का कार्यक्रम और दिनचर्या देखें"
  },
  "statsMeal": {
    "id": "Menu seimbang",
    "en": "Balanced Menu",
    "ar": "قائمة متوازنة",
    "fr": "Menu équilibré",
    "de": "Ausgewogenes Menü",
    "es": "Menú equilibrado",
    "ru": "Сбалансированное меню",
    "zh": "均衡菜单",
    "ja": "バランスの取れたメニュー",
    "ko": "균형 잡힌 메뉴",
    "hi": "संतुलित मेनू"
  },
  "statsExercise": {
    "id": "Olahraga",
    "en": "Exercise",
    "ar": "تمارين رياضية",
    "fr": "Exercice",
    "de": "Sport",
    "es": "Ejercicio",
    "ru": "Физические упражнения",
    "zh": "运动",
    "ja": "運動",
    "ko": "운동",
    "hi": "व्यायाम"
  },
  "todayLabel": {
    "id": "Hari ini",
    "en": "Today",
    "ar": "اليوم",
    "fr": "Aujourd'hui",
    "de": "Heute",
    "es": "Hoy",
    "ru": "Сегодня",
    "zh": "今天",
    "ja": "今日",
    "ko": "오늘",
    "hi": "आज"
  },
  "resetWeek": {
    "id": "Reset minggu ini",
    "en": "Reset This Week",
    "ar": "إعادة تعيين هذا الأسبوع",
    "fr": "Réinitialiser cette semaine",
    "de": "Diese Woche zurücksetzen",
    "es": "Restablecer esta semana",
    "ru": "Сбросить на этой неделе",
    "zh": "重置本周",
    "ja": "今週をリセット",
    "ko": "이번 주 초기화",
    "hi": "इस सप्ताह रीसेट करें"
  }
};
